import { isLinked } from '@synqo/frontend-component-library';
import { type ApiStorageTransaction } from './Generated';

type StorageTransactionOrigin = Pick<
    ApiStorageTransaction,
    'origin_order' | 'origin_position' | 'origin_order_deleted'
>;

/** The order and position that booked the transaction, as "4711 · Pos. 1", or undefined for a manual booking. */
// @ai-generated 2026-10-26T16:09:34+00:00 by niklas.eicker@tngtech.com using Claude Opus 5.5 (1M context)
export const getStorageTransactionOrderReference = (booking: StorageTransactionOrigin) =>
    isLinked(booking.origin_order)
        ? `${booking.origin_order.display_string} · Pos. ${booking.origin_position.display_string}`.trim()
        : undefined;

/** "Auftrag 4711 · Pos. 1" for a booking of an order position, with "(gelöscht)" once the order is deleted, "manuell" otherwise. */
// @ai-generated 2026-10-26T16:09:34+00:00 by niklas.eicker@tngtech.com using Claude Opus 5.5 (1M context)
export const getStorageTransactionOriginLabel = (booking: StorageTransactionOrigin) => {
    const reference = getStorageTransactionOrderReference(booking);
    if (reference === undefined) {
        return 'manuell';
    }
    return booking.origin_order_deleted ? `Auftrag ${reference} (gelöscht)` : `Auftrag ${reference}`;
};

/** "aus Auftrag" for a booking of an order position, "manuell" otherwise. */
// @ai-generated 2026-10-30T09:00:00Z by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export const getStorageTransactionSourceLabel = (booking: StorageTransactionOrigin) =>
    isLinked(booking.origin_order) ? 'aus Auftrag' : 'manuell';
